import { render, staticRenderFns } from "./VirtualBenefitFair.vue?vue&type=template&id=ba65f2c8&scoped=true&"
import script from "./VirtualBenefitFair.vue?vue&type=script&lang=js&"
export * from "./VirtualBenefitFair.vue?vue&type=script&lang=js&"
import style0 from "./VirtualBenefitFair.vue?vue&type=style&index=0&id=ba65f2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba65f2c8",
  null
  
)

export default component.exports